import type { ApiResponse } from "@/types/apiResponse";
import type { SignInFormData } from "../type/auth";

const singUp = async (data: SignInFormData): Promise<ApiResponse> => {
  const response = await fetch(`${API_HOST}/v1/usuario/registro`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error("No se pudo crear el usuario");

  const resData = await response.json();
  if (resData.status !== 201) {
    throw {
      status: resData.status,
      message: resData.message || "Error al registrar usuario",
    };
  }
  return resData;
};

export default singUp;
